import { render } from "./ReviewContactContent.vue?vue&type=template&id=e39ca0aa&scoped=true"
import script from "./ReviewContactContent.vue?vue&type=script&lang=js"
export * from "./ReviewContactContent.vue?vue&type=script&lang=js"

import "./ReviewContactContent.vue?vue&type=style&index=0&id=e39ca0aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e39ca0aa"]])

export default __exports__